import { Component, Mixins } from '@/vue-property-decorator'
import { GetCssVarManager } from '../../../components/baseCssVarProvide'
import { _CssVarCustom, _CssVarManagerBase } from './cssVarCustom'
import AdvertisementBox from '../components/advertisementBox'
import BaseCssVarInject from '../../../components/baseCssVarInject'
import BasePropsConfig, { VerticalProps } from '../components/basePropsConfig'
import BoxCut, { BoxCutBase } from '../../components/boxCut'
import CssVarDefault from './cssVarDefault'
import CssVarSmall from './cssVarSmall'
import FallbackBackground from '../../components/fallbackBackground'
import FavoriteIcon from '../../components/favoriteIcon'
import GameNameVertical from './gameNameVertical'
import LabelGameStatus from '../../components/labelGameStatus'
import MaskMaintain from '../../components/maskMaintain'
import OuterBox from '../components/outerBox'
import VirtualBorder from '../../components/virtualBorder'
/** 本卡片的样式声明 */
export type VerticalBottomNameCyanBlueCssVarManager =
  GetCssVarManager<_CssVarManagerBase>
export type VerticalPropsCyanBlue = VerticalProps

/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<VerticalBottomNameCyanBlue>({
  name: 'VerticalBottomNameCyanBlue'
})
export default class VerticalBottomNameCyanBlue extends Mixins<
  BasePropsConfig,
  // eslint-disable-next-line @typescript-eslint/ban-types
  BaseCssVarInject<{ cssType: string }, { boxCut?: BoxCutBase }>
>(BasePropsConfig, BaseCssVarInject) {
  /** 自定义样式,不含有任何默认样式 */
  public static CssVarCustom = _CssVarCustom
  /** 默认样式 */
  public static CssVarDefault = CssVarDefault
  /** 小号样式 */
  public static CssVarSmall = CssVarSmall
  /** 获得props */
  public static getProps = BasePropsConfig.getProps

  render() {
    const { isMaintain, isFavorited, isCompleteImage, isShowFavorited } = this
      .cardProps as VerticalPropsCyanBlue
    const { status } = this
    return (
      <OuterBox
        class={{
          ['vertical-bottom-name-cyan-blue']: true
        }}
        onClick={this.handleClickCard}
      >
        <BoxCut cssVarManagerMust={this.cssVarManagerMust?.boxCut}>
          {/* 兜底背景图 */}
          <FallbackBackground></FallbackBackground>
          <AdvertisementBox>
            {/* 如果是完整的一张图片,则不用渲染游戏名称的内容了 */}
            {!isCompleteImage && <GameNameVertical></GameNameVertical>}
          </AdvertisementBox>
          <template slot="cutSuspense">
            {/* 游戏状态标签 */}
            <LabelGameStatus status={status} />
            {/* 维护状态悬浮层 */}
            {isMaintain && <MaskMaintain />}
          </template>
          {/* unCut插槽中的元素,不会被overflow:hidden裁剪 */}
          <template slot="unCutSuspense">
            {/* 高亮的虚拟边框 */}
            <VirtualBorder borderUrl={VirtualBorder.getBorderUrlCyanBlue()} />
            {isShowFavorited && (
              <FavoriteIcon
                isFavorited={isFavorited}
                onClick={this.handleClickFavorIcon}
              >
                <FavoriteIcon.CircleStar></FavoriteIcon.CircleStar>
              </FavoriteIcon>
            )}
          </template>
        </BoxCut>
      </OuterBox>
    )
  }
}
